import gsap, { SplitText,ScrollTrigger,DrawSVGPlugin } from "gsap/all";
gsap.registerPlugin(SplitText,ScrollTrigger,DrawSVGPlugin);

export default [
    {
        name: "fadeIn",
        callback: (el, params, observerDelegate) => {
            switch(params.dir||'none'){
                case 'left': gsap.set(el, { opacity: 0,xPercent:10 });break;
                case 'right': gsap.set(el, { opacity: 0,xPercent:-10 });break;
                case 'bottom': gsap.set(el, { opacity: 0,yPercent:-25 });break;
                case 'top': gsap.set(el, { opacity: 0,yPercent:25 });break;
                default: gsap.set(el, { opacity: 0 });
            }

            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                const tweenProps = { duration: params.duration ?? 1, delay: params.delay ?? 0 };
                switch(params.dir||'none'){
                    case 'left': gsap.to(el, { opacity: 1,xPercent:0, ...tweenProps });break;
                    case 'right': gsap.to(el, { opacity: 1,xPercent:0, ...tweenProps });break;
                    case 'bottom': gsap.to(el, { opacity: 1,yPercent:0, ...tweenProps });break;
                    case 'top': gsap.to(el, { opacity: 1,yPercent:0, ...tweenProps });break;
                    default: gsap.to(el, { opacity: 1, ...tweenProps });break;
                }
            })
        }
    },
    {
        name: "slideIn",
        callback: (el, params, observerDelegate) => {
            switch(params.dir||'none'){
                case 'left': gsap.set(el, { opacity: 1,xPercent:10 });break;
                case 'right': gsap.set(el, { opacity: 1,xPercent:-10 });break;
                case 'bottom': gsap.set(el, { opacity: 1,yPercent:-25 });break;
                case 'top': gsap.set(el, { opacity: 1,yPercent:25 });break;
            }
           
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                switch(params.dir||'none'){
                    case 'left': gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1 });break;
                    case 'right': gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1 });break;
                    case 'bottom': gsap.to(el, { opacity: 1,yPercent:0, duration: params.duration ?? 1 });break;
                    case 'top': gsap.to(el, { opacity: 1,yPercent:0, duration: params.duration ?? 1 });break;
                    default: gsap.to(el, { opacity: 1, duration: params.duration ?? 1 });break;
                }
                gsap.to(el, { opacity: 1,xPercent:0, duration: params.duration ?? 1 })
            })
        }
    },
    {
        name: "revealer", // Affiche un mot ou phrase mot par mot
        callback: (el, params,observerDelegate) => {
            // gsap.set(el, { rotateX: '90deg', 'display': 'inline-block' })
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                const tl = gsap.timeline();
                const split = new SplitText(el, { type: "words,chars" });
                const chars = split.chars;
                tl.from(chars, {
                    duration: 0.15,
                    opacity: 0,
                    yPercent: 25,
                    transformOrigin: "50% 0%",
                    ease: "back",
                    stagger: 0.05
                });
            })
        }
    },
    {
        name:"draw", // Permet de faire une animation avec un svg qui est un path
        callback: (el, params, observerDelegate) => {
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                gsap.from(el, {duration:2,drawSVG: 0,delay:params.delay ?? 0.5});
            })
        }
    },
    {
        name: 'fadeInChild', // Fade in des enfants directs en stagger
        callback: (el, params, observerDelegate) => {
            const content = el.querySelector('.content') ?? el;
            const children = Array.from(content.children);
            gsap.set(children, { opacity: 0, yPercent: 15 });
            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                gsap.to(children, {
                    opacity: 1,
                    yPercent: 0,
                    duration: params.duration ?? 1,
                    stagger: params.stagger ?? 0.15,
                    ease: 'power2.out'
                });
            });
        }
    },
    {
        name: 'fadeinchild',
        callback: (el, params = {}, observerDelegate) => {
            const children = gsap.utils.toArray(el.querySelectorAll('.post-wrapper'));

            if (!children.length) return;

            gsap.set(children, {
                opacity: 0,
                y: params.distance ?? 12
            });

            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);

                gsap.to(children, {
                    opacity: 1,
                    y: 0,
                    duration: params.duration ?? 0.9,
                    stagger: params.stagger ?? 0.3
                });
            }, {
                offset: params.offset ?? '100%'
            });
        }
    },
    {
        name: 'counter', // Anime un nombre de 0 (ou `from`) jusqu'à la valeur du textContent
        callback: (el, params, observerDelegate) => {
            const raw = el.textContent.trim();
            const match = raw.match(/^([^0-9-]*)(-?[0-9.,]+)(.*)$/);
            const autoPrefix = match ? match[1] : '';
            const autoSuffix = match ? match[3] : '';
            const target = parseFloat(raw.replace(/[^0-9.-]/g, ''));
            const suffix = (params.suffix !== undefined && params.suffix !== '') ? params.suffix : autoSuffix;
            const prefix = (params.prefix !== undefined && params.prefix !== '') ? params.prefix : autoPrefix;
            const decimals = parseInt(params.decimals ?? 0);
            const from = parseFloat(params.from ?? 0);

            el.textContent = prefix + from.toFixed(decimals) + suffix;

            observerDelegate.observe(el, () => {
                observerDelegate.unobserve(el);
                const obj = { val: from };
                gsap.to(obj, {
                    val: target,
                    duration: parseFloat(params.duration ?? 2),
                    delay: parseFloat(params.delay ?? 0),
                    ease: 'power1.out',
                    onUpdate() {
                        el.textContent = prefix + obj.val.toFixed(decimals) + suffix;
                    }
                });
            });
        }
    },
    {
        name: 'parallax', // Permet de changer la vitesse de scroll d'un élément
        callback: (el, params) => { // les params sont yStart, yEnd 
            let mm = gsap.matchMedia();
  
            mm.add({
                isMobile: "(max-width:768px)",
                isDesktop: "(min-width:769px)"
            }, (context) => {
                let { isMobile, isDesktop } = context.conditions;
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        scrub: params.scrub ?? 1,
                    },
                });
                if(!isMobile){
                    tl.set(el, { transition:'transform 0.1s ease',display: 'inline-block', y: isDesktop ? params.yStart ?? 0 : (params.yStart ?? 0) / 2 });
                    tl.to(el, {
                        y: isDesktop ? params.yEnd ?? 0 : (params.yEnd ?? 0) / 2,
                        ease: params.ease ?? "power1"
                    });
                }
               
            })
        }
    },
]